import React, { useState, useEffect } from 'react';
import './SecciPopup.css';

/**
 * Component to display the SECCI document in a popup or append to body
 */
const SecciPopup = ({ isOpen, onClose, fetchDocument }) => {
  const [secciDocument, setSecciDocument] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isOpen) {
      setLoading(true);
      fetchDocument()
          .then(data => {
            setSecciDocument(data);
            setLoading(false);
            appendSecciToBody(data);
          })
          .catch(err => {
            console.log(err)
            setError('Failed to load SECCI document');
            setLoading(false);
          });
    }
  }, [isOpen, fetchDocument]);

  const appendSecciToBody = (secciContent) => {
    if (!secciContent) return;
    const existingContainer = window.document.getElementById('secci-body-container');
    if (existingContainer) {
      window.document.body.removeChild(existingContainer);
    }

    const secciContainer = window.document.createElement('div');
    secciContainer.id = 'secci-body-container';
    secciContainer.className = 'secci-body';

    const contentWrapper = window.document.createElement('div');
    contentWrapper.className = 'secci-content-wrapper';
    contentWrapper.innerHTML = secciContent;

    const closeButton = window.document.createElement('button');
    closeButton.innerText = '×';
    closeButton.className = 'secci-body-close';
    closeButton.onclick = () => {
      window.document.body.removeChild(secciContainer);
      onClose();
    };

    contentWrapper.prepend(closeButton);
    secciContainer.appendChild(contentWrapper);
    window.document.body.appendChild(secciContainer);
  };

  if (!isOpen) return null;

  if (loading || error) {
    return (
        <div className="popup-overlay">
          <div className="popup-content">
            <button className="close-button" onClick={onClose}>×</button>

            {loading && (
                <div className="popup-loading">Loading document...</div>
            )}

            {error && (
                <div className="popup-error">{error}</div>
            )}
          </div>
        </div>
    );
  }
  return null;
};

export default SecciPopup;
